import React, { ButtonHTMLAttributes } from 'react';
import Router from 'next/router';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

// theme
import { spacing, fontSizes, theme } from '../../utils';

// // components
// import { Spinner } from "../Spinner";
// import { ArrowRightIcon, CheckIcon } from "../Icon";

const selectorSizeProps = {
  default: {
    fontSize: fontSizes['medium'],
    padding: `${spacing['xsmall']} ${spacing['small']}`,
  },
  large: {
    fontSize: fontSizes['xmedium'],
    padding: `${spacing['small']} ${spacing['medium']}`,
  },
};

const getPropsByVariant = ({ variant }) => {
  // default
  const defaultVariantProps = {
    main: {
      color: theme.palette.grey[400],
      fontWeight: theme.typography.fontWeight.semibold,
      cursor: 'pointer',
      textAlign: 'center',
      borderRadius: theme.bordedRadius.regular,
      boxShadow: theme.shadows.large,
      userSelect: 'none',
      display: 'flex',
      alignItems: 'center',
    },
    hover: {
      backgroundColor: theme.palette.grey[600],
    },
    selected: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.grey[600],
    },
  };

  const variants = {
    default: defaultVariantProps,
  };

  return variants[variant];
};

// type
type SelectorProps = {
  size?: string;
  selected?: boolean;
  children?: any;
  onClick?: void;
};

export const Selector: React.FC<SelectorProps> = ({
  size = 'default',
  selected,
  onClick = (e) => e,
  children,
  ...rest
}) => {
  const variant = 'default';
  const fontSizeBySize = selectorSizeProps[size]?.fontSize;
  const paddingBySize = selectorSizeProps[size]?.padding;
  const propsByVariant = getPropsByVariant({ variant });
  const selectedVariant = selected && propsByVariant.selected;

  const styleSelector = {
    transition: 'all 0.5s ease-in-out',
    padding: paddingBySize,
    fontSize: fontSizeBySize,
    ...propsByVariant.main,
    '&:hover, &:focus': {
      ...(propsByVariant && propsByVariant.hover),
    },
    ...selectedVariant,
  };

  return (
    <div style={{ ...styleSelector }} onClick={onClick} {...rest}>
      {children}
    </div>
  );
};

export default Selector;
